import http from "./httpService.ts";
import type {IUser} from "../models/interfaces/user.interface.ts";
import type {
  IWorkspaceLanguageConfigurationDTO
} from "../models/interfaces/workspaceLanguageConfiguration.interface.ts";
import type {
  NewProjectConfigurationConfigDTO,
  NewProjectConfigurationDTO
} from "../models/interfaces/dtos/newProjectConfigurations.dto.ts";
import type {NewProjectConfigurationConfig} from "../models/interfaces/newProjectConfigurations.ts";

export const fetchUser = async (): Promise<IUser> => {
  const response = await http.get("/api/v1/users/me");
  return response.data;
};

export const getCustomConfigurations = async (): Promise<IWorkspaceLanguageConfigurationDTO[]> => {
  try {
    const response = await http.get(`api/v1/configurations/list`);
    return response.data as IWorkspaceLanguageConfigurationDTO[];
  } catch (err) {
    console.log("Error deleting")
    throw err;
  }
}

export const deleteUser: (password: string) => Promise<boolean> = async (password: string): Promise<boolean> => {
  try {
    const response = await http.delete("/api/v1/users/me", {data: {password}});
    return response.data as boolean; // isApprove boolean
  } catch (err) {
    console.error("Error deleting user:", err);
    throw err;
  }
}

export const getUserNewProjectCreationConfigurations = async (): Promise<NewProjectConfigurationDTO[]> => {
  try {
    const response = await http.get("/api/v2/configurations/workspace/deliverables");
    return response.data as NewProjectConfigurationDTO[];
  } catch (err) {
    console.error("Error fetching new project creation configurations:", err);
    throw err;
  }
}

export const createNewProjectConfiguration = async (name: string,sourceLanguage:string, configuration: NewProjectConfigurationConfig): Promise<NewProjectConfigurationDTO> => {
  try {
    const requestBody = {
      name: name,
      config:configuration,
      sourceLanguage: sourceLanguage
    }
    const response = await http.post("/api/v2/configurations/deliverables", requestBody);
    return response.data as NewProjectConfigurationDTO;
  } catch (err) {
    console.error("Error creating new project configuration:", err);
    throw err;
  }
}

export const editNewProjectConfiguration = async (id: string, name: string, configuration: NewProjectConfigurationConfig): Promise<NewProjectConfigurationDTO> => {
  try {
    const requestBody = {
      name,
      configuration
    }
    const response = await http.put(`/api/v2/configurations/deliverables?${id}`, requestBody);
    return response.data as NewProjectConfigurationDTO;
  } catch (err) {
    console.error("Error creating new project configuration:", err);
    throw err;
  }
}

export const deleteNewProjectConfiguration = async (id: string): Promise<void> => {
  try {
    await http.delete(`/api/v2/configurations/deliverables/${id}`);
  } catch (err) {
    console.error("Error creating new project configuration:", err);
    throw err;
  }
}

